import { Camera3D, Scene3D, WebGLRenderer3D } from 'feng3d-three';
import { PeppersGhostEffect } from '../thirdparty/three/imports';

export class PeppersGhostEffect3D
{
    _peppersGhostEffect: PeppersGhostEffect;

    get cameraDistance()
    {
        return this._peppersGhostEffect.cameraDistance;
    }
    set cameraDistance(v)
    {
        this._peppersGhostEffect.cameraDistance = v;
    }

    constructor(renderer: WebGLRenderer3D)
    {
        this._peppersGhostEffect = new PeppersGhostEffect(renderer._webGLRenderer);
    }

    setSize(width: number, height: number)
    {
        this._peppersGhostEffect.setSize(width, height);
    }

    render(scene: Scene3D, camera: Camera3D)
    {
        // 修复渲染前更新摄像机矩阵数据
        // @see https://github.com/mrdoob/three.js/blob/r149/src/renderers/WebGLRenderer.js#L963
        camera.updateMatrixWorld();
        //
        this._peppersGhostEffect.render(scene._scene, camera._camera);
    }
}
